// src/routes/AppRoutes.tsx
import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../pages/Home";
import ChotBuddiesHome from "../pages/ChotBuddies/Home";
import ChotStudyHome from "../pages/ChotStudy/Home";
import PrivacyPolicy from "../pages/ChotBuddies/PrivacyPolicy";
import ChotStudyPrivacyPolicy from "../pages/ChotStudy/PrivacyPolicy";
import DeleteAccount from "../pages/ChotBuddies/DeleteAccount";
import ChotStudyDeleteAccount from "../pages/ChotStudy/DeleteAccount";
import ScrollToTop from "../components/ScrollToTop";
import Terms from "../pages/ChotBuddies/Terms";
import ChotStudyTerms from "../pages/ChotStudy/Terms";
import ContactUs from "../pages/ContactUs";
import About from "../pages/About";
import Products from "../pages/Products";
import Blog from "../pages/Blog";
import BlogPostPage from "../pages/BlogPost";
import NotFound from "../pages/NotFound";

const AppRoutes: React.FC = () => (
  <>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/products/chot-buddies/" element={<ChotBuddiesHome />} />
      <Route
        path="/products/chot-buddies/privacy-policy/"
        element={<PrivacyPolicy />}
      />
      <Route
        path="/products/chot-buddies/delete-account/"
        element={<DeleteAccount />}
      />
      <Route
        path="/products/chot-buddies/terms/"
        element={<Terms />}
      />
      <Route path="/products/chot-study/" element={<ChotStudyHome />} />
      <Route
        path="/products/chot-study/privacy-policy/"
        element={<ChotStudyPrivacyPolicy />}
      />
      <Route
        path="/products/chot-study/delete-account/"
        element={<ChotStudyDeleteAccount />}
      />
      <Route
        path="/products/chot-study/terms/"
        element={<ChotStudyTerms />}
      />
      <Route path="/about/" element={<About />} />
      <Route path="/products/" element={<Products />} />
      <Route path="/blog/" element={<Blog />} />
      <Route path="/blog/:slug/" element={<BlogPostPage />} />
      <Route path="/contact-us/" element={<ContactUs />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </>
);

export default AppRoutes;
